export const setCookie = (cookieName, cookieValue, expirationDays = 365) => {
  const d = new Date()
  d.setTime(d.getTime() + (expirationDays * 24 * 60 * 60 * 1000))
  const expires = "expires=" + d.toUTCString()
  document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/"
}

export const getCookie = cookieName => {
  const decodedCookie = cookieName && decodeURIComponent(document.cookie).trim()
  const cookies = decodedCookie && decodedCookie.split(';')
  const cookieValue = cookies && cookies.length && cookies.find(cookie => {
    const cookieParts = cookie && cookie.trim().split('=')
    return cookieParts && cookieParts.length === 2 && cookieParts[0].trim() === cookieName
  })
  return cookieValue && cookieValue.trim().substr(cookieName.length + 1)
}

export const removeCookie = cookieName => {
  setCookie(cookieName, null, -1)
}